const ufeApi = require('services/api/ufeApi');
const { X_REFERRAL_TTL_TOKEN } = require('components/Campaigns/Referrer/constants');

// https://confluence.sephora.com/wiki/display/ILLUMINATE/RMS+enrollment+API
function enrollCampaign({
    userId, referrerCode, campaignCode, referralToken
}) {
    const url = '/api/campaign/enroll/';

    return ufeApi.makeRequest(url, {
        method: 'POST',
        headers: { [X_REFERRAL_TTL_TOKEN]: referralToken },
        body: JSON.stringify({
            userId,
            referrerCode,
            campaignCode
        })
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = enrollCampaign;
